import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/core/services/configuration/configuration.service';

@Component({
  selector: 'app-manage-parametros-modal',
  templateUrl: './manage-parametros-modal.component.html',
  styleUrls: ['./manage-parametros-modal.component.css']
})
export class ManageParametrosModalComponent implements OnInit {

  myForm: FormGroup;
  @Input() parametroId = 0;
  parametros: any;

  @Output() successEmit: EventEmitter<any> = new EventEmitter<any>();
  faTimes = faTimes
  constructor(
    public formbuild          : FormBuilder,
    public activeModal        : NgbActiveModal,
    private configurationService	: ConfigurationService,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
    if (this.parametroId) {
      this.obtenerParametro();
    }
  }

  initForm() {
    this.myForm = this.formbuild.group({
      parametro: [null, [Validators.required]],
      descripcion: [null, [Validators.required]],
      valor: [null, [Validators.required]],
    });
  }
  
  setForm(item) {
    for (const key in item) {
      if (this.myForm.controls[key]) {
        this.myForm.controls[key].setValue(item[key]);
      }
    }
  }

  obtenerParametro() {
    this.configurationService.obtenerParametro(this.parametroId)
    .then(res => {
      this.parametros = res;
      this.setForm(res);
    })
    .catch(error => {
      console.error(error);
    });
  }

  onSubmit() {
    if(this.myForm.valid) {
      const data = this.myForm.value;

      this.configurationService.guardarParametro(this.myForm.value, this.parametroId)
      .then(res => {
        this.successEmit.emit();
        this.activeModal.close(true);
      }).
      catch(error => {
        this.activeModal.close(false);
      });
    }
  }

}
